import {
  GET_RECRUITMENT,
  CHANGE_CURRENT_RECRUITMENT_PAGE,
SET_RECRUITMENT_ITEMS_PER_PAGE,
GET_WORKFLOW_FINAL,
CHANGE_CURRENT_WORKFLOW_FINAL_PAGE,
SET_WORKFLOW_FINAL_ITEMS_PER_PAGE
} from "../actions/projectLaunchAction";

const initialState = {
  recruitmentList: [],
  recruitmentPricingHistory: [],
  recruitmentSearchText: "",
  recruitmentAppliedFunctionFilter: [],
  recruitmentAppliedRolesFilter: [],
  recruitmentAppliedStatusFilter: [],
  recruitmentAppliedRecruiterFilter: [], 
  recruitmentAppliedBDManagerFilter: [],
  recruitmentAppliedNoOfDaysFilter: [],
  recruitmentAppliedDateFilter: [],
  recruitmentTotalResults: null,
  recruitmentCurrentPage: 1,
  recruitmentResultsPerPage: 10,
  recruitmentTotalPages: null,
  recruitmentPageIds: [],
  recruitmentFunctionFilter: [],
  recruitmentRolesFilter: [],
  recruitmentRecruiterFilter: [],
  recruitmentBDManagerFilter: [],
  recruitmentNoOfDaysFilter: [],
  recruitmentViewReopenReason: {},
  projectInfo: {},
  fetchingData: true,
  workflowFinalResultsPerPage:10,
  workflowFinalCurrentPage:1
};

const recruitmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_RECRUITMENT: {
      const newList =
    state.recruitmentCurrentPage === 1
      ? action.payload.result.results                // first page → replace
      : [...state.recruitmentList, ...action.payload.result.results]; 
      return {
        ...state,
        recruitmentList: newList,
        recruitmentTotalResults: action.payload.result.total_results,
        recruitmentTotalPages: action.payload.result.total_pages,
        recruitmentPageIds: action.payload.result.page_ids,
        recruitmentFunctionFilter: action.payload.filter_data.functions,
        recruitmentRolesFilter: action.payload.filter_data.roles,
        recruitmentRecruiterFilter: action.payload.filter_data.recruiters,
        recruitmentBDManagerFilter: action.payload.filter_data.bd_managers,
        recruitmentNoOfDaysFilter: action.payload.filter_data.no_of_days,
        fetchingData: false,
      };
    }
    case CHANGE_CURRENT_RECRUITMENT_PAGE: {
      return {
        ...state,
        recruitmentCurrentPage: action.payload,
      };
    }
    case SET_RECRUITMENT_ITEMS_PER_PAGE: {
      return {
        ...state,
        recruitmentResultsPerPage: action.payload,
      };
    }
     case GET_WORKFLOW_FINAL: {
      return {
        ...state,
        workflowFinalList: action.payload.result.results,
        workflowFinalTotalResults: action.payload.result.total_results,
        workflowFinalTotalPages: action.payload.result.total_pages,
        workflowFinalPageIds: action.payload.result.page_ids,
        workflowFinalRolesFilter: action.payload.filter_data.roles,
        workflowFinalSkillsFilter: action.payload.filter_data.skills,
        workflowFinalAvailableHoursFilter:
          action.payload.filter_data.total_available_hours,
        candidatesListFilterFlexiSelected:
          action.payload.filter_data.flexibees_selected || [],
        candidatesListFilterActiveProjects:
          action.payload.filter_data.active_projects || [],
        fetchingData: false,
      };
    }
    case CHANGE_CURRENT_WORKFLOW_FINAL_PAGE: {
      return {
        ...state,
        workflowFinalCurrentPage: action.payload,
      };
    }
    case SET_WORKFLOW_FINAL_ITEMS_PER_PAGE: {
      return {
        ...state,
        workflowFinalResultsPerPage: action.payload,
      };
    }
    default:
      return state;
  }
};

export default recruitmentReducer;
